import { createMemoStyles } from '@wds/styles';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { MD_MEDIA_QUERY } from '~shared/media-query';

export default createMemoStyles(({ spacing, type, pricingPalette }: PricingAppTheme) => ({
  SocialProofContainer: {
    display: 'none',
    [MD_MEDIA_QUERY]: {
      display: 'flex',
      flexWrap: 'nowrap',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: type.fontSize.bodySm,
      margin: [spacing[4], spacing[3], 0],
      paddingBottom: spacing[2],
      fontWeight: type.fontWeight.medium,
      color: pricingPalette.colors.slate,
    },
  },

  Logos: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing[3],

    '& svg': {
      padding: [0, 10],
    },
  },

  TrustedBy: {
    flex: '0 1 auto',
    textAlign: 'center',
    fontSize: type.fontSize.caption,
  },
}));
